<template>
  <div
    v-if="isChattingWithAi"
    class="tw:size-[30px] tw:*:size-[30px] tw:text-center tw:rounded-full tw:border tw:shrink-0"
  >
    <i class="tw:i-fad-message-bot tw:text-primary" />
  </div>
  <MessageAvatar
    v-else
    :display-name="userDisplayName"
    :image-url="userPhotoUrl"
  />
</template>

<script setup>
import { MessageAvatar } from '@/components/common/message/index.js'
import { useQuickConversation } from './use-quick-conversation.js'

const { isChattingWithAi, userDisplayName, userPhotoUrl } = useQuickConversation()
</script>
